import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import BrandMark from './BrandMark';
import './auth/auth.css';

// Return of the Shopify app login: store the token, check it, go to the app.
// Nothing about the token or the account is printed (it used to be shown on
// the page and in the console: decoded JWT + the whole /users/user answer).
const ShopifyCallback = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleShopifyLogin = async () => {
      const params = new URLSearchParams(location.search);
      const token = params.get('token');
      if (!token) {
        navigate('/');
        return;
      }
      try {
        const decodedToken = jwt_decode(token);
        localStorage.setItem('access_token', token);
        if (decodedToken.shop) {
          localStorage.setItem('shop', decodedToken.shop);
        }
        await axios.get('/api/users/user', {
          headers: { Authorization: `Bearer ${token}` },
        });
        navigate('/dashboard');
      } catch (error) {
        console.error('Shopify login verification failed:', error?.response?.status || error.message);
        navigate('/');
      }
    };

    handleShopifyLogin();
  }, [location, navigate]);

  return (
    <div className="auth-page">
      <div className="auth-callback" role="status" aria-live="polite">
        <BrandMark size={36} className="auth-callback-mark" />
        <span className="u-skeleton auth-callback-bar" />
        <p>{t('publicUi.shopifyConnecting', 'Connexion à votre boutique Shopify…')}</p>
      </div>
    </div>
  );
};

export default ShopifyCallback;
